// -----------------------------------------------------------------------------
// Script for pop up
// -----------------------------------------------------------------------------

function popUp() {

  $('.popup-1 .popup__close').on('click', function () {
    $('.popup').fadeOut('slow');
    $('.popup-2').fadeIn('slow');
  });

  $('.popup-1').on('click', function () {
    $('.popup-1').fadeOut('slow');
    $('.popup-2').fadeIn('slow');
  });

  $('.popup-2 .popup__wrapper--two .popup__close').on('click', function () {
    $('.popup__wrapper--two').fadeOut('slow');
  });

  $('.popup-2 .popup__wrapper--three .popup__close').on('click', function () {
    $('.popup__wrapper--three').fadeOut('slow');
  });

  $('.popup-2').on('click', function () {
    $(this).fadeOut('slow');
  }).children().click(function(e) {
    
  });

}